import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { Chip } from 'components/chips'
import { MichiganSOSBundleDto } from 'dtos'
import { formatDate } from 'utils'

interface MichiganSOSBundlesDetailsCardProps {
  michiganSOSBundle: MichiganSOSBundleDto
}

export default function MichiganSOSBundlesDetailsCard({
  children,
  michiganSOSBundle
}: React.PropsWithChildren<MichiganSOSBundlesDetailsCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} alignItems='flex-start'>
          <Grid item xs={12} container alignContent='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container spacing={1}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5'>
                  Michigan SoS Bundle Details
                </Typography>
              </Grid>

              {michiganSOSBundle.isLocked && (
                <Grid item>
                  <Chip variant='red'>BUNDLE LOCKED</Chip>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm='auto'>
              {children}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={6} md={3}>
            <LabelField label='Owner' value={michiganSOSBundle.michiganTitleOwnerName} />
          </Grid>

          <Grid item xs={6} md={3}>
            <LabelField
              label='Created'
              value={
                michiganSOSBundle.createdDateTime
                  ? `${formatDate(michiganSOSBundle.createdDateTime)} by ${
                      michiganSOSBundle.createdByPerson
                        ? `${michiganSOSBundle.createdByPerson.firstName} ${
                            michiganSOSBundle.createdByPerson.lastName || ''
                          }`.trim()
                        : '-'
                    }`
                  : '-'
              }
            />
          </Grid>

          <Grid item xs={6} md={3}>
            <LabelField
              label='Modified'
              value={
                michiganSOSBundle.updatedDateTime
                  ? `${formatDate(michiganSOSBundle.updatedDateTime)} by ${
                      michiganSOSBundle.updatedByPerson
                        ? `${michiganSOSBundle.updatedByPerson.firstName} ${
                            michiganSOSBundle.updatedByPerson.lastName || ''
                          }`.trim()
                        : '-'
                    }`
                  : '-'
              }
            />
          </Grid>

          <Grid item xs={6} md={3}>
            <LabelField
              label='Title Application Delivery Photo Uploaded'
              value={
                michiganSOSBundle.titleApplicationDeliveryPhotoUploadedDateTime
                  ? formatDate(michiganSOSBundle.titleApplicationDeliveryPhotoUploadedDateTime)
                  : ''
              }
            />
          </Grid>

          <Grid item xs={6} md={3}>
            <LabelField label='Count' value={michiganSOSBundle.vehicleCount} />
          </Grid>

          <Grid item xs={6} md={3}>
            <LabelField
              label='Bundle Completed'
              value={michiganSOSBundle.bundleCompletedDateTime ? formatDate(michiganSOSBundle.bundleCompletedDateTime) : ''}
            />
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Bundle Locked Chip:**

Displays when a bundle is marked as locked.

**Back Button:**

Clicking this button navigates the user to the previous screen.

**Generate MI Title Application Cover Letter Button:**

Clicking this button generates the MI Title Application Cover Letter PDF.

This button is enabled only when the MI SoS Bundle is locked.

**Lock/Unlock Bundle Button:**

Lock Bundle Button: Clicking this button locks the bundle and changes the button text to "Unlock Bundle."

Unlock Bundle Button: Clicking this button unlocks the bundle.

**Delete bundle Button:**

Clicking this button deletes the bundle.

MI SoS Bundles can only be deleted if the bundle is not locked.

**Edit Button:**

Clicking this button opens the Edit Michigan SoS Bundle dialog.

This button is enabled only if the bundle is not locked.

**Owner Column:**

Displays the owner’s name from the Owner Name field under Vehicle Details > Titles (tab).

**Created:**

Displays the date and user who created the bundle.

**Modified:**

Displays the date and user who most recently modified the bundle.

**Title Application Delivery Photo Uploaded:**

Displays the date the Title Application Delivery Photo was uploaded.

**Count:**

Displays the total number of vehicles in the bundle.

**Bundle Completed:**

This field is populated with the date that the last vehicle associated with the MI SoS Bundle had its Michigan Title Application Receipt added to the vehicle.`}
            </GreenText>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
